/**
 * What this form's document is, in one clause.
 *
 * Printed wherever a step or an ending decides to SEND it, so the person
 * ticking the box knows what will arrive without opening another tab. The
 * wording follows the two things the Document tab shows — your PDF, and the
 * parts — rather than the derived mode, because "composed" is our word.
 */
import type { FormSettingsView } from '../../api/forms';
import { templatesOf } from '../../api/forms';

export function documentSummary(document: FormSettingsView['document']): string {
  const parts = document?.blocks?.length || 0;
  const templates = templatesOf(document);
  if (parts) {
    const fromPdf = (document?.blocks || []).filter((b) => b.type === 'template').length;
    return `${parts} part${parts === 1 ? '' : 's'}`
      + (fromPdf ? `, ${fromPdf} from your ${templates.length > 1 ? 'PDFs' : 'PDF'}` : '');
  }
  if (templates.length > 1) {
    const pages = templates.reduce((n, t) => n + t.pages, 0);
    return `your ${templates.length} PDFs, ${pages} pages`;
  }
  if (templates[0]) {
    return `your PDF, ${templates[0].pages} page${templates[0].pages === 1 ? '' : 's'}`;
  }
  return 'the branded record';
}
